export const SYSTEM_POST_TYPES = [
    {
        name: 'Базовый',
        id: -2,
        color: ''
    },
    {
        name: 'Реклама',
        id: -1,
        color: 'success'
    },
    {
        name: 'Коллаборация',
        id: 0,
        color: 'processing'
    }
]

export const basePostType = {
    name: 'Базовый',
    color: ''
}

export const advertisingPostType = {
    name: 'Реклама',
    color: 'success'
}

export const collaborationPostType = {
    name: 'Коллаборация',
    color: 'processing'
}
